/**
 *
 * Checkbox
 *
 */

import { Grid, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { Checkbox as SharedCheckbox } from 'src/Checkbox';

import Caption from '../../Typography/Caption';
import styles from './styles';

/**
 * @internal
 */
function Checkbox(props) {
  const {
    classes,
    input: { value, onChange },
    meta: { touched, error },
  } = props;
  return (
    <Grid
      alignItems="center"
      className={`${classes.root} ${classes.checkboxRoot}`}
      container
      direction="row"
      wrap="nowrap"
    >
      <Grid item>
        <SharedCheckbox checked={value || false} onChange={onChange} />
      </Grid>
      {touched && error && (
        <Caption align="right" classes={{ root: classes.error }} color="error">
          {error}
        </Caption>
      )}
    </Grid>
  );
}

Checkbox.propTypes = {
  classes: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
};

/**
 * @internal
 */
export default withStyles(styles)(memo(Checkbox));
